import axios from 'axios'
import store from '@/store'
import QS from 'qs'
import router from '../router/index'
import { Message, Loading  } from 'element-ui'

const showMessage = Symbol('showMessage')
// 重写，避免Message提示重复出现
class DonMessage {
    success (options, single = true) {
      this[showMessage]('success', options, single)
    }
    warning (options, single = true) {
      this[showMessage]('warning', options, single)
    }
    info (options, single = true) {
      this[showMessage]('info', options, single)
    }
    error (options, single = true) {
      this[showMessage]('error', options, single)
    }
  
    [showMessage] (type, options, single) {
        if (single) {
            // 判断是否已存在Message
            if (document.getElementsByClassName('el-message').length === 0) {
                Message[type](options)
            }
        } else {
            Message[type](options)
        }
    }
}
var MessageOnce = new DonMessage();

console.log('baseURL=======',process.env.VUE_APP_BASEURL)

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,
    timeout: 10000,
})




// 设置局部loading样式-----------------------------------------------------------------------------------------------------------------------
    let loading;
    function startLoading() {
        loading = Loading.service({
            lock: true,
            text: "Loading...",
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.2)',
            target: document.querySelector('.main')//设置加载动画区域
        });
    }
    function endLoading() {
        loading.close();
    }
    
    //声明一个对象用于存储请求个数
    let needLoadingRequestCount = 0
    function showFullScreenLoading() {
        if (needLoadingRequestCount === 0) {
            startLoading();
        }
        needLoadingRequestCount++;
    };
    function tryHideFullScreenLoading() {
        if (needLoadingRequestCount <= 0) return;
        needLoadingRequestCount--;
        if (needLoadingRequestCount === 0) {
            endLoading();
        }
    }

// -----------------------------------------------------------------------------------------------------------------------


service.interceptors.request.use(
    config => {
        // showFullScreenLoading()

		if (store.getters.getToken) {
			config.headers['token'] = store.getters.getToken
        }
		return config
	},
	error => {
		// tryHideFullScreenLoading()
		return Promise.reject(error)
	}
)


service.interceptors.response.use(
	response => {
        tryHideFullScreenLoading()
		
		if (response.status === 200) {
            switch (response.data.errorcode) {
                case 403:
                case 4033:
                    store.commit('Logout')
                    MessageOnce.error({message: '请重新登录!'})
                    setTimeout(() => {
                        router.push({ path: '/login' }).catch(err => {})
                    }, 1000);
                    break;
                case 4003:
                    MessageOnce.error({message: '该用户已被禁用，请联系管理员!'})
                    break
                case 4032:
                    MessageOnce.error({message: '该用户没有权限!'})
                    break
            
                default:
                    break;
            }
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }

	},
	error => {
        tryHideFullScreenLoading()
		console.log('err' + error) // for debug
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)


/**
 * 封装get方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function get(url, params, config, hideLoading) {

    // if(!hideLoading) showFullScreenLoading()

    return new Promise((resolve, reject) => {
        service.get(url, { params: params }).then(response => {
            resolve(response.data)
        }, err => {
            reject(err.data)
        })
    })
}

/**
 * 封装post请求
 * @param url
 * @param params
 * @returns {Promise}
 */
export function post(url, params, config, hideLoading) {

    // if(!hideLoading) showFullScreenLoading()

    return new Promise((resolve, reject) => {
        let data = config?params:QS.stringify(params)
        service.post(url, data, config)
        .then(response => {
            resolve(response.data)
        }, err => {
            reject(err)
        })
    })
}




// WEBPACK FOOTER //
// ./src/utils/request.js